import { createAppStore } from '@store/createAppStore';

import {
  CustomerLTLSettingState,
  ICspSetup,
  ILTLCustomerData,
  ILtlCustomerSettingState,
  TestLaneState,
} from './types';

const [customerLTLSettings, setCustomerLTLSettingsLegacy] =
  createAppStore<CustomerLTLSettingState>(
    {
      isLoading: true,
      isError: false,
      errorMessage: '',
      settings: {} as ILTLCustomerData,
      cspSetup: {
        ltlScacAccountTypes: {
          payerTypes: [],
          termTypes: [],
          serviceLevelTypes: [],
          pricingRequestTypes: [],
        },
      } as unknown as ICspSetup,
    },
    'customerLTLSettings',
  );
const [testLaneStore, setTestLaneStore] = createAppStore<TestLaneState>(
  {
    isLoading: false,
    isError: false,
    errorMessage: '',
    hasTestedLane: false,
    testResultsSuccess: [],
    testResultsFailure: [],
    quoteParameters: null,
  },
  'testLaneStore',
);
const [ltlCustomerSetting, setLtlCustomerSetting] =
  createAppStore<ILtlCustomerSettingState>(
    {
      isLoading: false,
      isError: false,
      errorMessage: '',
      data: {
        customerId: 0,
        quoteExpirationDays: null,
        carrierSelectionStrategyType: null,
        enableCustomerPortalAutoDispatch: null,
        enableSuggestedClass: null,
        enableAgentQuotesInCustomerPortal: null,
        enableCustomerSpecificPricing: null,
        enableLtlInCustomerPortal: null,
        enableMixedCommodities: null,
        enablePrePro: null,
        emailAgentIfShipmentNotBuilt: null,
        emailAgentIfNoQuoteResult: null,
        disableBolInCustomerPortal: null,
        enableLtlGapLogic: null,
        gapCompressionPercentage: null,
        insuranceTermsAccepted: null,
        carriers: [],
      },
    },
    'ltlCustomerSetting',
  );

export {
  customerLTLSettings,
  ltlCustomerSetting,
  setCustomerLTLSettingsLegacy,
  setLtlCustomerSetting,
  setTestLaneStore,
  testLaneStore,
};
